import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  GlobalSearchTermDocumentsData,
  GlobalSearchTermDocumentDataPoint,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { GlobalSearchTermDocumentsConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "global-search-term-documents-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class GlobalSearchTermDocumentsChartComponent
  extends BaseChartLogic<GlobalSearchTermDocumentsConfig, GlobalSearchTermDocumentsData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      GlobalSearchTermDocumentsConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.globalSearchTermDocumentsDataChange);
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(dataPoint: GlobalSearchTermDocumentDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.FilterByMinimum = this.config?.minUsed || null;
  }

  refreshData(): void {
    this.analyticsService.getGlobalSearchTermDocumentsData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}